import { useEffect, useState } from "react";
import { ArrowRight, Radio } from "lucide-react";
import { fetchGuestCalendar } from "@/lib/api";
import { countdown, fmtLocal } from "@/lib/calendar";

export const NextRecordingStrip = () => {
  const [next, setNext] = useState(null);

  useEffect(() => {
    fetchGuestCalendar().then((d) => setNext(d.next)).catch(() => {});
  }, []);

  if (!next) return null;
  const cd = countdown(next.recording_at_utc);

  return (
    <a
      href="/calendar"
      data-testid="atfq-next-strip"
      className="group block bg-[#0A192F] text-white border-y border-white/10 hover:bg-[#0d2140] transition-colors"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
        <span className="inline-flex items-center gap-2 text-[var(--accent)] text-xs uppercase tracking-widest">
          <Radio className={`w-3.5 h-3.5 ${cd.live ? "animate-pulse" : ""}`} /> {cd.live ? "Recording now" : "Next recording"}
        </span>
        <span className="font-display text-base md:text-lg tracking-tight" data-testid="atfq-next-strip-name">{next.name}</span>
        <span className="text-white/70">{fmtLocal(next.recording_at_utc)}</span>
        {next.rescheduled && <span data-testid="atfq-next-strip-rescheduled" className="text-[10px] uppercase tracking-wider border border-amber-300 text-amber-200 px-1.5 py-0.5">Rescheduled</span>}
        {!cd.live && <span className="font-mono text-xs text-white/60" data-testid="atfq-next-strip-countdown">in {cd.label}</span>}
        <span className="ml-auto inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-white/80 group-hover:text-white">
          Calendar &amp; questions <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </a>
  );
};

export default NextRecordingStrip;
